// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-red[data-v-2cb2e6ec] {
  color: var(--elem-red-color);
}
.color-green[data-v-2cb2e6ec] {
  color: green;
}
.color-blue[data-v-2cb2e6ec] {
  color: var(--toolbtn-active-color);
}
.publication-editor[data-v-2cb2e6ec] {
  width: 100%;
}
.publication-editor .publication-editor-main[data-v-2cb2e6ec] {
  margin: 15px 5%;
}
.publication-editor .publication-editor-main[data-v-2cb2e6ec] .with-imgs-list .del-item {
  position: absolute;
}
.publication-editor .publication-editor-main > div[data-v-2cb2e6ec]:not(:last-child) {
  margin-bottom: 10px;
}
.publication-editor .publication-editor-main .name-text[data-v-2cb2e6ec] {
  outline: none;
}
.publication-editor .publication-editor-main .user-signature[data-v-2cb2e6ec] {
  width: 100%;
}
.publication-editor .publication-editor-main .user-signature label[data-v-2cb2e6ec] {
  margin-right: 0;
}
.publication-editor .publication-editor-main .user-signature i[data-v-2cb2e6ec] {
  cursor: pointer;
  padding: 5px;
  margin: auto auto auto 0;
}
.publication-editor .publication-editor-main .title-input[data-v-2cb2e6ec],
.publication-editor .publication-editor-main .info-placeholder[data-v-2cb2e6ec],
.publication-editor .publication-editor-main .info-input[data-v-2cb2e6ec] {
  font-size: 1.1em;
}
.publication-editor .publication-editor-main .info-input[data-v-2cb2e6ec] {
  min-height: 34px;
}
.publication-editor .publication-editor-main .title-input[data-v-2cb2e6ec],
.publication-editor .publication-editor-main .info-input[data-v-2cb2e6ec] {
  /*margin: auto !important;
                border: none !important;
                box-shadow: none !important;
                background-color: white !important;
                outline: none;*/
  width: 100%;
}
.publication-editor .publication-editor-footer[data-v-2cb2e6ec] {
  margin: 15px 5%;
}
.publication-editor .publication-editor-footer .btns[data-v-2cb2e6ec] {
  display: flex;
}
.publication-editor .publication-editor-footer .btns i[data-v-2cb2e6ec] {
  height: 42px;
  line-height: 42px;
  width: 52px;
  vertical-align: middle;
  text-align: center;
  color: var(--icon-roundbtn-color);
  font-size: 20px;
  cursor: pointer;
}
.publication-editor .publication-editor-footer .btns i[data-v-2cb2e6ec]:hover {
  background: var(--btn-bghover);
}
.publication-editor .publication-editor-footer .btns i[data-v-2cb2e6ec]:active {
  background: var(--pub-footer-active);
}
.publication-editor .publication-editor-footer .btns .clip[data-v-2cb2e6ec] {
  width: 44px;
  height: 44px;
  margin: 0 20px 0 0;
  border: 1px solid var(--list-item-bordercolor);
  border-radius: 10px;
}
.publication-editor .publication-editor-footer .btns .add-files-btns[data-v-2cb2e6ec] {
  border: 1px solid var(--message-left-bgcolor);
  border-radius: 10px;
  overflow: hidden;
  height: 44px;
}
.publication-editor .publication-editor-footer .btns .add-files-btns i[data-v-2cb2e6ec] {
  overflow: hidden;
}
.publication-editor .publication-editor-footer .btns .add-files-btns i[data-v-2cb2e6ec]:not(:last-child) {
  border-right: 1px solid var(--message-left-bgcolor);
}
.publication-editor .contact-item[data-v-2cb2e6ec],
.publication-editor .audios-item[data-v-2cb2e6ec],
.publication-editor .file-item[data-v-2cb2e6ec],
.publication-editor .geo-location-item[data-v-2cb2e6ec] {
  width: 88%;
}
.publication-editor .geo-location-item[data-v-2cb2e6ec]:not(.edit) {
  cursor: pointer;
}
.publication-editor .poll-block .poll-msg[data-v-2cb2e6ec] {
  width: 88%;
}
.publication-editor .poll-block .edit-icons[data-v-2cb2e6ec] {
  margin-left: auto;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/channels/ChannelPublicationEditor.vue"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE;;;;+BAI6B;EAC7B,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mDAAmD;AACrD;AACA;;;;EAIE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB","sourcesContent":[".color-red[data-v-2cb2e6ec] {\n  color: var(--elem-red-color);\n}\n.color-green[data-v-2cb2e6ec] {\n  color: green;\n}\n.color-blue[data-v-2cb2e6ec] {\n  color: var(--toolbtn-active-color);\n}\n.publication-editor[data-v-2cb2e6ec] {\n  width: 100%;\n}\n.publication-editor .publication-editor-main[data-v-2cb2e6ec] {\n  margin: 15px 5%;\n}\n.publication-editor .publication-editor-main[data-v-2cb2e6ec] .with-imgs-list .del-item {\n  position: absolute;\n}\n.publication-editor .publication-editor-main > div[data-v-2cb2e6ec]:not(:last-child) {\n  margin-bottom: 10px;\n}\n.publication-editor .publication-editor-main .name-text[data-v-2cb2e6ec] {\n  outline: none;\n}\n.publication-editor .publication-editor-main .user-signature[data-v-2cb2e6ec] {\n  width: 100%;\n}\n.publication-editor .publication-editor-main .user-signature label[data-v-2cb2e6ec] {\n  margin-right: 0;\n}\n.publication-editor .publication-editor-main .user-signature i[data-v-2cb2e6ec] {\n  cursor: pointer;\n  padding: 5px;\n  margin: auto auto auto 0;\n}\n.publication-editor .publication-editor-main .title-input[data-v-2cb2e6ec],\n.publication-editor .publication-editor-main .info-placeholder[data-v-2cb2e6ec],\n.publication-editor .publication-editor-main .info-input[data-v-2cb2e6ec] {\n  font-size: 1.1em;\n}\n.publication-editor .publication-editor-main .info-input[data-v-2cb2e6ec] {\n  min-height: 34px;\n}\n.publication-editor .publication-editor-main .title-input[data-v-2cb2e6ec],\n.publication-editor .publication-editor-main .info-input[data-v-2cb2e6ec] {\n  /*margin: auto !important;\n                border: none !important;\n                box-shadow: none !important;\n                background-color: white !important;\n                outline: none;*/\n  width: 100%;\n}\n.publication-editor .publication-editor-footer[data-v-2cb2e6ec] {\n  margin: 15px 5%;\n}\n.publication-editor .publication-editor-footer .btns[data-v-2cb2e6ec] {\n  display: flex;\n}\n.publication-editor .publication-editor-footer .btns i[data-v-2cb2e6ec] {\n  height: 42px;\n  line-height: 42px;\n  width: 52px;\n  vertical-align: middle;\n  text-align: center;\n  color: var(--icon-roundbtn-color);\n  font-size: 20px;\n  cursor: pointer;\n}\n.publication-editor .publication-editor-footer .btns i[data-v-2cb2e6ec]:hover {\n  background: var(--btn-bghover);\n}\n.publication-editor .publication-editor-footer .btns i[data-v-2cb2e6ec]:active {\n  background: var(--pub-footer-active);\n}\n.publication-editor .publication-editor-footer .btns .clip[data-v-2cb2e6ec] {\n  width: 44px;\n  height: 44px;\n  margin: 0 20px 0 0;\n  border: 1px solid var(--list-item-bordercolor);\n  border-radius: 10px;\n}\n.publication-editor .publication-editor-footer .btns .add-files-btns[data-v-2cb2e6ec] {\n  border: 1px solid var(--message-left-bgcolor);\n  border-radius: 10px;\n  overflow: hidden;\n  height: 44px;\n}\n.publication-editor .publication-editor-footer .btns .add-files-btns i[data-v-2cb2e6ec] {\n  overflow: hidden;\n}\n.publication-editor .publication-editor-footer .btns .add-files-btns i[data-v-2cb2e6ec]:not(:last-child) {\n  border-right: 1px solid var(--message-left-bgcolor);\n}\n.publication-editor .contact-item[data-v-2cb2e6ec],\n.publication-editor .audios-item[data-v-2cb2e6ec],\n.publication-editor .file-item[data-v-2cb2e6ec],\n.publication-editor .geo-location-item[data-v-2cb2e6ec] {\n  width: 88%;\n}\n.publication-editor .geo-location-item[data-v-2cb2e6ec]:not(.edit) {\n  cursor: pointer;\n}\n.publication-editor .poll-block .poll-msg[data-v-2cb2e6ec] {\n  width: 88%;\n}\n.publication-editor .poll-block .edit-icons[data-v-2cb2e6ec] {\n  margin-left: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
